import { GraphQLResult, GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { Modal } from "antd";
import { API } from "aws-amplify";
import React from "react";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import {
  AccountMovement,
  GenerateGameSessionTokenAtlasMutation,
  GetMovementQuery,
} from "../../API";
import { useAppSelector } from "../../app/hooks";
import { selectPlayer } from "../../features/player/playerSlice";
import {
  Localization,
  selectTheme,
  showLoading,
  ThemeColor,
  ThemeMode,
} from "../../features/theme/themeSlice";
import { generateGameSessionTokenAtlas } from "../../graphql/mutations";
import { getMovement } from "../../graphql/queries";
import useAccount from "../../hooks/useAccount";
import AppLocale from "../../lang";
import PrintPlacebet from "../account/components/PrintPlacebet";

const Sport: React.FC = () => {
  const dispatch = useDispatch();
  const theme = useAppSelector(selectTheme);
  const { accountRefresh } = useAccount();
  const [printTicket, setPrintTicket] = useState<number>(0);
  const [modalTicket, setModalTicket] = useState<boolean>(false);
  const intl = useIntl();
  const player = useAppSelector(selectPlayer);
  const [ticketMovement, setTicketMovement] = useState<AccountMovement | null>(
    null
  );
  /* localization */
  const locale: Localization = theme.language as any;
  const languages: any = { it: "ITA", en: "ENG" };
  const language = languages[locale];
  const currentAppLocale = AppLocale[locale];

  const iframeDeskRef: any = React.createRef();

  const [sessionToken, setSessionToken] = useState<any | null>(null);

  const generateSessionToken = () => {
    let lastPrintedId: number | null = 0;
    (async () => {
      const result: GraphQLResult<GenerateGameSessionTokenAtlasMutation> =
        (await API.graphql({
          query: generateGameSessionTokenAtlas,
          authMode: player.logged
            ? GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
            : GRAPHQL_AUTH_MODE.AWS_IAM,
          variables: {
            staging: true,
            lang: language,
            category: "sport",
            currency: player.logged ? player.account?.valute : "EUR",
          },
        })) as GraphQLResult<GenerateGameSessionTokenAtlasMutation>;

      if (!result.errors) {
        setSessionToken(result.data?.generateGameSessionTokenAtlas);
        window.addEventListener("message", (event) => {
          if (event.data.action === "ui:goto") {
            /* console.info("UI:GOTO", event.data.payload); */
          }
        //  console.log("IFRAME EVENT", event);
          if (event.data.action === "bet:placedSuccess") {
            if (lastPrintedId != event.data.payload.data.bets[0].betId) {
              lastPrintedId = event.data.payload.data.bets[0].betId;
              setPrintTicket(lastPrintedId);
              console.log(
                "print bet id: ",
                event.data.payload.data.bets[0].betId
              );
            }
          }
        });
      }
    })();
  };

  useEffect(() => {
    if (iframeDeskRef.current) {
      if (theme.theme == ThemeColor.light) {
        iframeDeskRef.current.contentWindow.postMessage(
          {
            action: "ui:theme_change",
            payload: "light",
          },
          "*"
        );
      } else {
        iframeDeskRef.current.contentWindow.postMessage(
          {
            action: "ui:theme_change",
            payload: "dark",
            
          },
          "*"
        );
      }
    }
  }, [theme.theme]);
  /*************** */

  useEffect(() => {
    if (printTicket !== 0 && theme.mode === ThemeMode.KIOSK) {
      (async () => {
        try {
          const result: GraphQLResult<GetMovementQuery> = (await API.graphql({
            query: getMovement,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: {
              PK: `ATLAS#BETID#${printTicket}`,
            },
          })) as GraphQLResult<GetMovementQuery>;
          setTicketMovement(result.data.getMovement);
          setModalTicket(true);
          console.log(result);
        } catch (e) {
          alert("errore \n" + JSON.stringify(e));
          setPrintTicket(0);
        }
      })();
    }
  }, [printTicket]);

  useEffect(() => {
    if (sessionToken) {
      console.log(sessionToken);
    }
  }, [sessionToken]);

  useEffect(() => {
    //alert("LOGGED" + player.logged);
    if (player.logged && player.account && !sessionToken) {
      generateSessionToken();
    }
  }, [player.logged, player.account]);

  useEffect(() => {
  }, []);
  return (
<div className="d-sport">
<iframe src="https://www.goplay365.com/?iframe=true#!/" style={{border:'none',outline:'none', width:'100%',position:'fixed', height:'100%'}} />
</div>

   
  );
};

export default Sport;
